//Action Types
export const CONNECT_WALLET = "CONNECT_WALLET";
export const DIS_WALLET = "DIS_WALLET";

//Action Creator
export const connectWallet = () => ({
  type: CONNECT_WALLET
});

export const disconnectWallet = () => ({
  type: DIS_WALLET
});
